import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ibanFormat',
    pure: false
})
export class IbanFormatPipe implements PipeTransform {

    constructor() {
    }

    transform(value: any) {
        if (!value) {
            return null;
        }

        return value.split(' ').join('').replace(/(.{4})/g, "$1 ").trim();
    }
}
